<div class="transport-capacity-container">
<section class="service-transport-container">
    <div class="capacity-header">
        {{'transportCapacity.transportCapacitySetup'| translate}}
        <div class="controls">
            <div class="cancel"(click)="onCancelClicked()" 
            [ngClass]="isMaxSlotsPerDayEdited ||isMaxSlotsPerTimePeriodEdited ?'enabled':''">
            {{'overrideCapacity.cancel'| translate}}
            </div>
            <div class="save" (click)="onSaveClicked()" 
            [ngClass]="isMaxSlotsPerDayEdited ||isMaxSlotsPerTimePeriodEdited ?'enabled':''">
            {{'overrideCapacity.save'| translate}}
            </div>
        </div>
    </div>

    <div class='capacity-options' >
        <div class='capacity-view-transport' [ngClass]="viewMode == transport.SHUTTLE ? 'selected':''"
            (click)="formsEdited()?showAlert(transport.SHUTTLE):loadView(transport.SHUTTLE)">{{'common.Shuttle'| translate}}</div>
        <div class='capacity-view-transport' [ngClass]="viewMode == transport.RENTAL ? 'selected':''"
            (click)="formsEdited()?showAlert(transport.RENTAL):loadView(transport.RENTAL)">{{'common.Rental'| translate}}
        </div>
        <div class='capacity-view-transport' [ngClass]="viewMode == transport.REMOTE ? 'selected':''"
            (click)="formsEdited()?showAlert(transport.REMOTE):loadView(transport.REMOTE)">{{'common.Remote'| translate}}
        </div>
    </div>
</section>

<app-loading class="loading" size=".5" *ngIf="loading; else transportView" color="var(--primary-sec-color)"></app-loading>
<ng-template #transportView>
    
    <div style="padding-left: 1rem; display: inline-grid; width: 98%;">
        <app-transport-max [viewMode]="viewMode" [transportMaxTotal$]="maxTotal$ | async"
        (saveChanges)="onTotalSaveChanges($event)" 
        [switchInput]="loadedView"
        [saveClicked]="isShuttleSlotsPerDaySaveClicked"
        [cancleClicked]="isCancelClicked"
        (formEdited)="maxSlotsPerDayFormEdited($event)"
         (cancleClick)="resetCancleClickValue($event)"
         (saveClick)="resetSaveClickedValue($event)">
        </app-transport-max>
    </div>
    <div style="display: inline-block;margin-bottom: 10px;width:100%;padding:1rem 1rem 0 1rem;">
        <div style="float: left;">
            <div>
               {{viewModeText(viewMode)}}
            </div>
        </div>
        <div style="float: right;margin-right: 20px;">
            <div style="float: left;font-size: 12px;padding-right: 5px;padding-top: 4px;">{{'departmentCapacity.activate'| translate}}</div>
            <div style="float: right;">
                <app-onofswitch *ngIf='viewMode == transport.SHUTTLE' [switchInput]='shuttleActivate' (switchChange)="updateSwitchValues($event, 'shuttle')"></app-onofswitch>
                <app-onofswitch *ngIf='viewMode == transport.RENTAL' [switchInput]='rentalActivate' (switchChange)="updateSwitchValues($event, 'rental')"></app-onofswitch>
                <app-onofswitch *ngIf='viewMode == transport.REMOTE' [switchInput]='remoteActivate' (switchChange)="updateSwitchValues($event, 'remote')"></app-onofswitch>
            </div>
        </div>
    </div>
   
    <div style="padding:1rem; overflow-y: scroll;">
        <app-timeslot-grid *ngIf="masterSlotsLoading$ | async"
            [viewMode]="viewMode"
            [slotDetails$]="slotDetails$ | async"
            [maxAndMasterSlots$]="maxAndMasterSlots$ | async"
            (saveChanges)="onSlotsSaveChanges($event)"
            [switchInput]="loadedView"
            [saveClicked]="isSavedClicked"
            (formEdited)="maxSlotsPerTimeTableFormEdited($event)"
            [cancleClicked]="isMaxSlotsPerTimePeriodCancleClicked"
            (cancleClick)="resetCancleClickedPerTimePeriod($event)"
            [department]="department">
        </app-timeslot-grid>
    </div>
</ng-template>
</div>
